<div [ngStyle]="{'width': width, 'height': height}">
    <img [lazyLoad]="imageUrl" style="height: 100%; width: 100%;" *ngIf="imageName">
    <img style="height: 100%; width: 100%;" lazyLoad="/assets/images/no-img-available.png" *ngIf="!imageName">
</div>